import ScoutToggle from "../../components/Toggle/ScoutToggle";
import PageIntro from "../../components/PageIntro/PageIntro";

export default function Settings() {
  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <PageIntro
        title="Settings"
        description="Manage platform-wide configurations and preferences."
      />

      {/* House card: rounded-2xl border bg-card shadow, rows own their padding */}
      <section className="overflow-hidden rounded-2xl border bg-card shadow-ui-sm">
        <div className="border-b px-5 py-4">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-brand-orange">
            Platform
          </div>
          <h2 className="font-display text-lg font-semibold text-brand-navy">
            Platform Features
          </h2>
        </div>

        <div className="space-y-6 p-5 sm:p-6">
          <ScoutToggle />

          <div className="border-t pt-6">
            <div className="flex cursor-not-allowed items-center justify-between opacity-50">
              <div className="flex flex-col">
                <p className="text-sm font-medium text-brand-navy">
                  Maintenance Mode
                </p>
                <p className="text-xs text-muted-foreground">Coming soon</p>
              </div>
              <div className="relative h-6 w-10 rounded-full bg-muted">
                <div className="absolute left-1 top-1 h-4 w-4 rounded-full bg-card" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
